import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const IconZorroCase = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_299_3873)">
          <path
            d="M4.00012 18C4.00012 17.5847 4.00012 14.669 4.00012 12.3324C4.00012 10.6755 5.34332 9.33307 7.00024 9.33315C8.53229 9.33322 10.1477 9.33329 10.5001 9.33329H20.0928C20.4898 9.33329 22.9334 9.3334 25.0004 9.33349C26.6572 9.33356 28.0001 10.6765 28.0001 12.3333C28.0001 13.7716 28.0001 15.2568 28.0001 15.5999V20C28.0001 20.3896 28.0001 22.0693 28.0001 23.6668C28.0001 25.3237 26.6573 26.6666 25.0005 26.6666C23.0797 26.6666 20.915 26.6666 20.5001 26.6666H11.0001H7.00006C5.34318 26.6666 4.00003 25.3234 4.00006 23.6666C4.00009 21.8749 4.00012 19.8757 4.00012 19.5V18Z"
            stroke="#1A1721"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.6668 14.6667H15.3335C14.8031 14.6667 14.2944 14.8423 13.9193 15.1549C13.5442 15.4675 13.3335 15.8914 13.3335 16.3334C13.3335 16.7754 13.5442 17.1994 13.9193 17.5119C14.2944 17.8245 14.8031 18.0001 15.3335 18.0001H16.6668C17.1973 18.0001 17.706 18.1757 18.081 18.4882C18.4561 18.8008 18.6668 19.2247 18.6668 19.6667C18.6668 20.1088 18.4561 20.5327 18.081 20.8453C17.706 21.1578 17.1973 21.3334 16.6668 21.3334H13.3335"
            stroke="#1A1721"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 21.4999V22.6666M16 13.3333V14.4999"
            stroke="#1A1721"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.6665 9.33333V6.66667C10.6665 5.95942 10.9475 5.28115 11.4476 4.78105C11.9477 4.28095 12.6259 4 13.3332 4H18.6665C19.3737 4 20.052 4.28095 20.5521 4.78105C21.0522 5.28115 21.3332 5.95942 21.3332 6.66667V9.33333"
            stroke="#1A1721"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_299_3873">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
